import {Uchain} from "../redux/api/agent";
import { call, put, takeEvery } from 'redux-saga/effects';
import { sagaActions } from './sagaActions';
import { addFileUploadSuccess, addFileUploadFailure,initiateLoading,resetData } from '../redux/reducers/reducerSlices/FileuploadReducer';
import axios from "axios";
  function* addUploadFileHandler(data){
    try{
      yield put(initiateLoading());
      const response = yield call(Uchain.uploadFile, data.payload.fd);
     
       response.name=data.payload.name;
     yield put(addFileUploadSuccess(response));
    }catch(error){
     yield put(addFileUploadFailure(error));
    }
}

  function* addUploadFileByBucketNameSaga(data) {
    try {
      yield put(initiateLoading());
      const response = yield call(Uchain.uploadFileByBucketName, data.payload.fd);

      response.name = data.payload.name;
      yield put(addFileUploadSuccess(response));
    } catch (error) {
      yield put(addFileUploadFailure(error));
    }
  }

export function* addUploadFileHandlerWithPresign(data) {
  try {
    yield put(initiateLoading());

    const file = data.payload.fd.get("file");

    const presignRes = yield call(Uchain.getPresignedUrl, {
      fileName: file.name,
      contentType: file.type,
    });

    if (!presignRes?.uploadUrl || !presignRes?.fileUrl) {
      const error= new Error("Invalid presigned URL response");
       yield put(addFileUploadFailure(error));
        return
    }

    const { uploadUrl, fileUrl } = presignRes;

  yield call(
      axios.put,
      uploadUrl,
      file,
      {
        headers: {
          "Content-Type": file.type,
        },
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
      }
    );

     const response = {
      name: data.payload.name,
      fileUrl,
    };

    yield put(addFileUploadSuccess(response));
  } catch (error) {
    yield put(addFileUploadFailure(error));
  }
}


export function* addUploadFileRequest() {
  yield takeEvery(sagaActions.FILE_UPLOAD, addUploadFileHandler)
}

export function* addUploadFileByBucketNameWatcher() {
  yield takeEvery(sagaActions.FILE_UPLOAD_BY_BUCKET_NAME, addUploadFileByBucketNameSaga);
}

function* resetFileUploadDataHandler() {
    yield put(resetData())
    
   }
   export function*  resetFileUploadDataRequest() {
     yield takeEvery(sagaActions.RESET_FILE_UPLOAD, resetFileUploadDataHandler)
   }
   
export function* addUploadFileHandlerWithPresignWatcher() {
  yield takeEvery(sagaActions.FILE_UPLOAD_BY_PRESIGNED_URL, addUploadFileHandlerWithPresign);
}